import { useEffect } from "react";
import { CompaniesCard } from "./card";
import { CompaniesNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { CompaniesTable } from "./table";

export default function Companies() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Entreprises");
  }, []);

  return (
    <Routes>
      <Route index element={<CompaniesTable />} />
      <Route path="/new" element={<CompaniesNew />} />
      <Route path=":id" element={<CompaniesCard />} />
    </Routes>
  );
}
